/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetEmployeeDataFlowGraphPayload,
  GetEmployeeDataFlowGraphPayload$Outbound,
  GetEmployeeDataFlowGraphPayload$outboundSchema,
} from "../components/getemployeedataflowgraphpayload.js";

export type GetEmployeeDataFlowGraphSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetEmployeeDataFlowGraphSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetEmployeeDataFlowGraphSecurity = {
  option1?: GetEmployeeDataFlowGraphSecurityOption1 | undefined;
  option2?: GetEmployeeDataFlowGraphSecurityOption2 | undefined;
};

export type GetEmployeeDataFlowGraphRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getEmployeeDataFlowGraphPayload: GetEmployeeDataFlowGraphPayload;
};

/** @internal */
export type GetEmployeeDataFlowGraphSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetEmployeeDataFlowGraphSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetEmployeeDataFlowGraphSecurityOption1$Outbound,
    GetEmployeeDataFlowGraphSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getEmployeeDataFlowGraphSecurityOption1ToJSON(
  getEmployeeDataFlowGraphSecurityOption1:
    GetEmployeeDataFlowGraphSecurityOption1,
): string {
  return JSON.stringify(
    GetEmployeeDataFlowGraphSecurityOption1$outboundSchema.parse(
      getEmployeeDataFlowGraphSecurityOption1,
    ),
  );
}

/** @internal */
export type GetEmployeeDataFlowGraphSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetEmployeeDataFlowGraphSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetEmployeeDataFlowGraphSecurityOption2$Outbound,
    GetEmployeeDataFlowGraphSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getEmployeeDataFlowGraphSecurityOption2ToJSON(
  getEmployeeDataFlowGraphSecurityOption2:
    GetEmployeeDataFlowGraphSecurityOption2,
): string {
  return JSON.stringify(
    GetEmployeeDataFlowGraphSecurityOption2$outboundSchema.parse(
      getEmployeeDataFlowGraphSecurityOption2,
    ),
  );
}

/** @internal */
export type GetEmployeeDataFlowGraphSecurity$Outbound = {
  Option1?: GetEmployeeDataFlowGraphSecurityOption1$Outbound | undefined;
  Option2?: GetEmployeeDataFlowGraphSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetEmployeeDataFlowGraphSecurity$outboundSchema: z.ZodMiniType<
  GetEmployeeDataFlowGraphSecurity$Outbound,
  GetEmployeeDataFlowGraphSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetEmployeeDataFlowGraphSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetEmployeeDataFlowGraphSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getEmployeeDataFlowGraphSecurityToJSON(
  getEmployeeDataFlowGraphSecurity: GetEmployeeDataFlowGraphSecurity,
): string {
  return JSON.stringify(
    GetEmployeeDataFlowGraphSecurity$outboundSchema.parse(
      getEmployeeDataFlowGraphSecurity,
    ),
  );
}

/** @internal */
export type GetEmployeeDataFlowGraphRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetEmployeeDataFlowGraphPayload: GetEmployeeDataFlowGraphPayload$Outbound;
};

/** @internal */
export const GetEmployeeDataFlowGraphRequest$outboundSchema: z.ZodMiniType<
  GetEmployeeDataFlowGraphRequest$Outbound,
  GetEmployeeDataFlowGraphRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getEmployeeDataFlowGraphPayload:
      GetEmployeeDataFlowGraphPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getEmployeeDataFlowGraphPayload: "GetEmployeeDataFlowGraphPayload",
    });
  }),
);

export function getEmployeeDataFlowGraphRequestToJSON(
  getEmployeeDataFlowGraphRequest: GetEmployeeDataFlowGraphRequest,
): string {
  return JSON.stringify(
    GetEmployeeDataFlowGraphRequest$outboundSchema.parse(
      getEmployeeDataFlowGraphRequest,
    ),
  );
}
